<template lazy>
  <div class="rounded">
    <div class="px-3 py-2 header">
      <img src="@/assets/icons/circle-info.svg" class="mr-2" />
      <span class="font-16">{{ $i18n.t('ImportantInformation') }}</span>
    </div>
    <div
      v-if="this.userSelectedLang === this.lang.ES"
      class="p-3 font-14 bg-gray-21 color-gray-18"
    >
      <p>
        1 - Leer la Política Pública titulada Directrices y disposiciones para
        radicar la solicitud de autorización para realizar investigaciones y sus
        fases relacionadas: la validación de instrumentos o pruebas piloto en el
        Departamento de Educación de Puerto Rico.
      </p>
      <p>
        2 - Tenga todos sus documentos a mano. La plataforma tiene un
        temporizador por motivos de seguridad.
      </p>
      <p>
        3 - Grabe o escanee sus documentos en formato (pdf.*) para poderlos
        adjuntar a la plataforma.
      </p>
      <div>
        <p>
          4 - De tener alguna duda relacionada al trámite de la solicitud para
          realizar validación de instrumento o estudio piloto y fase final de la
          investigación, deberá comunicarse con:
        </p>
        <ol type="A" class="mt-3">
          <li>
            La Secretaría Auxiliar de Transformación, Planificación y
            Rendimiento Dirección:
            <span class="color-green-3">
              P.O. Box 190759 San Juan, Puerto Rico 00919-0759 Tel: 787 773
              4060, sanchez_is@de.pr.gov.
            </span>
          </li>
        </ol>
      </div>
      <p>
        5 - Se le notifica al investigador que una vez finalice el estudio o sus
        fases, será responsable de subir una copia del trabajo final en formato
        digital (.pdf) en nuestra Biblioteca Virtual. De no cumplir con esta
        disposición, el investigador se expone a que el DEPR no le autorice
        futuras investigaciones hasta cumplir con este requisito.
      </p>
    </div>
    <div
      v-if="this.userSelectedLang === this.lang.EN"
      class="p-3 font-14 bg-gray-21 color-gray-18"
    >
      <p>
        1 - Read the Public Policy titled Guidelines and provisions for
        submitting the authorization request to conduct research and its related
        phases: the validation of instruments or pilot tests at the Department
        of Education of Puerto Rico.
      </p>
      <p>
        2 - Have all your documents ready. The platform has a timer for security
        reasons.
      </p>
      <p>
        3 - Record or scan your documents in (pdf.*) format to be able to attach
        them to the platform.
      </p>
      <div>
        <p>
          4 - If you have any questions related to the process of submitting a
          validation request for an instrument or pilot study and the final
          phase of the research, you should contact:
        </p>
        <ol type="A" class="mt-3">
          <li>
            Assistant Secretary for Transformation, Planning, and Performance,
            Address:
            <span class="color-green-3">
              P.O. Box 190759 San Juan, Puerto Rico 00919-0759 Tel: 787 773
              4060, sanchez_is@de.pr.gov.
            </span>
          </li>
        </ol>
      </div>
      <p>
        5 - The researcher is notified that once the study or its phases are
        completed, they will be responsible for uploading a copy of the final
        work in digital format (.pdf) to our Virtual Library. Failure to comply
        with this requirement may result in the DEPR not authorizing future
        research until this requirement is fulfilled.
      </p>
    </div>
  </div>
</template>
<script>
import lang from '@/utils/constants/lang';

export default {
  name: 'ImportantInformation',
  computed: {
    lang() {
      return lang;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.header {
  background: map-get($colors, 'primary-4');
  color: map-get($colors, 'white');
  border-radius: 4px 4px 0px 0px;
  display: flex;
  align-items: center;
}
</style>
